import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, LogOut } from 'lucide-react';
import { api } from '@/lib/api';

export const ImpersonationBanner: React.FC = () => {
    const isImpersonating = !!sessionStorage.getItem('original_admin_token');

    if (!isImpersonating) return null;

    const handleStopImpersonation = () => {
        api.stopImpersonation();
    };

    return (
        <div className="bg-red-600 text-white px-4 py-2 flex items-center justify-between shadow-md z-50 relative">
            <div className="flex items-center space-x-2">
                <AlertTriangle className="h-5 w-5" />
                <span className="font-semibold">
                    You are currently impersonating another user. Actions you take will be attributed to them.
                </span>
            </div>
            <Button
                variant="secondary"
                size="sm"
                onClick={handleStopImpersonation}
                className="bg-white text-red-600 hover:bg-gray-100 border-none"
            >
                <LogOut className="mr-2 h-4 w-4" />
                Return to Admin
            </Button>
        </div>
    );
};
